export default __webpack_public_path__ + "static/media/popup-diagonal-right-top.79770d5c.svg";